
const platforms = [
  {
    name: 'Instagram',
    icon: 'fab fa-instagram',
    handle: '@brushour_',
    url: 'https://www.instagram.com/brushour_',
    description: 'Stunning before & after transformations, colour inspiration, and daily updates from our projects across Hertfordshire.',
    gradient: 'from-orange-400 to-pink-500',
    tag: 'Most Active',
    tagColor: 'bg-orange-100 text-orange-600',
  },
  {
    name: 'TikTok',
    icon: 'fab fa-tiktok',
    handle: '@brushour_',
    url: 'https://www.tiktok.com/@brushour_',
    description: 'Short-form painting transformation videos, quick decorating tips, and behind-the-scenes content. Follow for daily inspiration!',
    gradient: 'from-gray-700 to-gray-900',
    tag: 'New',
    tagColor: 'bg-gray-100 text-gray-700',
  },
  {
    name: 'Facebook',
    icon: 'fab fa-facebook',
    handle: '@brushour',
    url: 'https://www.facebook.com/brushour',
    description: 'Join our community for exclusive offers, customer testimonials, painting tips, and the latest news from Brushour.',
    gradient: 'from-sky-500 to-sky-700',
    tag: '3.2K Fans',
    tagColor: 'bg-sky-100 text-sky-700',
  },
  {
    name: 'YouTube',
    icon: 'fab fa-youtube',
    handle: '@brushour',
    url: 'https://www.youtube.com/@brushour',
    description: 'Video tutorials, time-lapse project videos, expert painting techniques, and comprehensive guides to our professional process.',
    gradient: 'from-red-500 to-red-700',
    tag: '1.8K Subs',
    tagColor: 'bg-red-100 text-red-600',
  },
  {
    name: 'Pinterest',
    icon: 'fab fa-pinterest',
    handle: 'Brushour',
    url: 'https://www.pinterest.com/brushour',
    description: 'Endless colour palette ideas, interior design inspiration, painting trends, and creative home transformation boards.',
    gradient: 'from-rose-500 to-red-600',
    tag: '2.5K Followers',
    tagColor: 'bg-rose-100 text-rose-600',
  },
  {
    name: 'WhatsApp',
    icon: 'fab fa-whatsapp',
    handle: 'Message Us',
    url: 'https://wa.me/447595037441?text=Hi%20Brushour!%20I%27d%20like%20to%20get%20a%20quote.',
    description: 'Get instant responses, request quick quotes, share project photos, and communicate directly with our team.',
    gradient: 'from-green-400 to-emerald-600',
    tag: 'Quick Reply',
    tagColor: 'bg-green-100 text-green-700',
  },
];

export default function SocialsPlatforms() {
  return (
    <section id="platforms" className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-orange-500 font-semibold uppercase tracking-widest text-sm mb-3">Where to find us</p>
          <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-5">
            Our Social <span className="text-orange-500">Channels</span>
          </h2>
          <p className="text-gray-500 text-lg max-w-2xl mx-auto">
            Each platform offers unique content — pick your favourite and stay connected with the Brushour team.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {platforms.map((platform, index) => (
            <a
              key={index}
              href={platform.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative flex flex-col bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 overflow-hidden cursor-pointer"
            >
              {/* Top gradient bar */}
              <div className={`h-1.5 w-full bg-gradient-to-r ${platform.gradient}`} />

              <div className="p-7 flex flex-col flex-1">
                {/* Icon + name row */}
                <div className="flex items-center justify-between mb-5">
                  <div className="flex items-center gap-4">
                    <div className={`w-14 h-14 flex items-center justify-center rounded-2xl bg-gradient-to-br ${platform.gradient} shadow-md`}>
                      <i className={`${platform.icon} text-white text-2xl`}></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-gray-900">{platform.name}</h3>
                      <p className="text-sm text-gray-400">{platform.handle}</p>
                    </div>
                  </div>
                  <span className={`text-xs font-semibold px-3 py-1 rounded-full whitespace-nowrap ${platform.tagColor}`}>
                    {platform.tag}
                  </span>
                </div>

                {/* Description */}
                <p className="text-gray-500 text-sm leading-relaxed flex-1 mb-6">
                  {platform.description}
                </p>

                {/* CTA */}
                <div className={`flex items-center gap-2 text-sm font-semibold bg-gradient-to-r ${platform.gradient} bg-clip-text text-transparent group-hover:gap-3 transition-all duration-300`}>
                  <span>Follow Now</span>
                  <i className="ri-arrow-right-line text-base text-gray-400 group-hover:text-orange-400 transition-colors"></i>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
